module.exports = __webpack_public_path__ + "static/media/builder-img.ceebd70d.jpg";